export default () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
  },
  button: {
    maxWidth: 250,

    '& .MuiButton-root': {
      borderRadius: 16,
    },
  },
});
